// Utility-method to build the payload for normalization (expiration date, etc.)
// Add/remove fields in RENTAL_VERSION_NORMALIZE_FIELDS as needed for future backend logic
export const RENTAL_VERSION_NORMALIZE_FIELDS = [
  'id',
  'name',
  'scheduleAttributes',
  'createdAt',
  'deliveryType',
  'deliveryAddressStreetAddress1',
  'deliveryAddressStreetAddress2',
  'deliveryAddressCity',
  'deliveryAddressLocale',
  'deliveryAddressPostalCode',
  'deliveryAddressCountry',
];

export function buildRentalVersionNormalizePayload(data: any) {
  const payload: any = {};
  for (const key of RENTAL_VERSION_NORMALIZE_FIELDS) {
    if (data[key] !== undefined) payload[key] = data[key];
  }
  return payload;
}
